export const RESEARCHZERO_URL = 'https://researchzero.io/';
export const WEB3PWN_URL = 'https://www.web3pwn.com/';
export const WEB3PWN_X_URL = 'https://x.com/web3pwn';
export const DISCORD_INVITE_URL = 'https://discord.gg/hQbJNgz5zS';
